module.exports = __webpack_public_path__ + "static/media/stat547u_lecture08.aa3514b4.pdf";